<div class="text-cell" 
     [style.font-size.px]="fontSize"
     [style.text-align]="textAlign"
     [style.font-weight]="fontWeight">
  <span *ngIf="displayText">{{ displayText }}</span>
  <span *ngIf="!displayText" class="placeholder">Text Cell</span>
</div>